import {} from '../utils/dateextend'
exports.setFilter =
    // 时间戳转字符(具体到秒数)
    function(Vue) {
        Vue.filter('detailDate',input => {
            if (input.indexOf("/Date") > -1   ){
              var time = parseInt(input.substring(6,input.length - 2));
              var d = new Date(time);
              return  d.Format('YYYY-MM-dd HH:mm:SS');
            }
            else {
              return input;
            }
        });

        // 时间戳转字符(具体到天数)显示年月日
        Vue.filter('dayDate', input => {
            var time = parseInt(input.substring(6,19));
            var d = new Date(time);
            var year = d.getFullYear();
            var month = d.getMonth() + 1;
            var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate();
            return  year+ '年' + month + '月' + day + '日';
        });

        // 时间戳转字符(具体到天数)显示斜杠
        Vue.filter('toDay', input => {
            var time = parseInt(input.substring(6,19));
            var d = new Date(time);
            return  d.Format('YYYY/MM/dd');
        });

        Vue.filter('dayTime', input => {
            if(!input){
                return ''
            }
            var time = parseInt(input.substring(6,19));
            var date = new Date(time);
            
            var seperator1 = "-";
            var seperator2 = ":";
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            
            var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
                    + " " + date.getHours() + seperator2 + date.getMinutes() + '0'
                    + seperator2 + date.getSeconds() + '0';

            // var currentdate = date.getFullYear() + '年' + month + '月' + strDate + '日' 
            //         + " " + date.getHours() + seperator2 + date.getMinutes() + '0'
            //         + seperator2 + date.getSeconds() + '0';

            // if( date.getMinutes() ==0 && date.getSeconds() ==0 &&  date.getHours() != 0  )
            if(  date.getHours() != 0  )
                return currentdate;   
            else
                return  date.getFullYear()+ '年' + month + '月' + strDate + '日';
        });

        // 给正数加个正号
        Vue.filter('discount', input => input > 0 ? '+' + input:input);

        //空或不存在返回‘无’
        Vue.filter('remark', input => (input==null||input=='')?'无':input);

        //空或不存在返回 0
        Vue.filter('toZero', input => (input==null||input==''||typeof(input)=="undefined"||isNaN(input))?0:input);

        //返回小数点后一位
        Vue.filter('fomatFloat',//input =>  parseInt(input));
        input =>  Math.round(input*Math.pow(10, 1))/Math.pow(10, 1));

        Vue.filter('fomatFloat2',//input =>  parseInt(input));
        input =>  Math.round(input*Math.pow(10, 2))/Math.pow(10, 2));

        //向上取整
        Vue.filter('toUpperInt',
        input => Math.ceil(input))
        
        //四舍五入
        Vue.filter('toRound',
        input => Math.round(input))

        //四舍五入保留1位
        Vue.filter('toFixed',input =>{
            var number = Number(input)
            if(number%1 === 0){
                return number
            }
            else{
                return number.toFixed(1)
            }
        })

        //+---------------------------------------------------  
        //| 时间戳转日期(年月日)
        //+---------------------------------------------------  
        Vue.filter('toShort',input => {
            var time = parseInt(input.substring(6, 19));
            var d = new Date(time);
            return d.Format('M月d日')
        })

        Vue.filter('commentRank',input =>{
            if (input <= 5)
            {
                return "点评新手";
            }
            else if (input > 5 && input <= 30)
            {
                return "点评达人";
            }
            else{
                return "点评大师";
            }
        })
    }    



// WEBPACK FOOTER //
// ./src/utils/filters.js